// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Home_wrapper__U7UwZ","button":"Home_button__3_K0L","text":"Home_text__3zRIA","header":"Home_header__1KviV"};